import styled from 'styled-components';
import { useRouter } from 'next/router';

import { ArrowLeftIcon } from '@components/icons';
import { H2 } from '@components/styles/Typography';

const BackButton = ({ title, tabletHide }) => {
    const router = useRouter();
    return (
        <ButtonContainer tabletHide={tabletHide}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div onClick={() => router.back()} data-testid="back-button">
                <ArrowLeftIcon width="18px" />
            </div>
            <H2>{title}</H2>
        </ButtonContainer>
    );
};

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    cursor: pointer;

    @media (max-width: 1024px) {
        display: ${({ tabletHide }) => (tabletHide ? 'none' : 'flex')};
    }
    @media (max-width: 768px) {
        display: none;
    }
`;
export default BackButton;
